module.exports = __webpack_public_path__ + "v294910/img/homepage.c51bf26c.png";